export class GcpGkeNamespaceResource {
    'clusterName';
    'name';
    'status';
    'creationTime';
    'persistentVolumeClaims';
    'secretsCount';
    'labels';
    'annotations';
    'resourceVersion';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "creationTime",
            "baseName": "creationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "persistentVolumeClaims",
            "baseName": "persistentVolumeClaims",
            "type": "Array<PersistentVolumeClaimProperties>",
            "format": ""
        },
        {
            "name": "secretsCount",
            "baseName": "secretsCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "annotations",
            "baseName": "annotations",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "resourceVersion",
            "baseName": "resourceVersion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpGkeNamespaceResource.attributeTypeMap;
    }
    constructor() {
    }
}
